import React, {Component} from 'react';
import {connect} from 'react-redux';

import {RouteKeys} from '../../constants';
import {
  ValidationService,
  StringService,
  NotificationService,
} from '../../services';
import {AiOutlineMinusCircle, AiOutlinePlusCircle} from 'react-icons/ai';
import validation from './validation';

import moment from 'moment';

import {ScreenNotificationDefault, Footer, InputText} from '../../components';
import {
  redirectToYourCard,
  redirectToSignature,
  redirectToValidationAccessCode,
  redirectToHireInsurance,
} from '../../ducks/Navigate';
import {
  updateProps,
  addCartaoAdicional,
  addNovoCartaoAdicional,
  processaSituacaoPortadorFinalizada,
  updateCartaoAdicional,
  removeCartaoAdicional,
  adicionarCartoesAdicionais,
  consultarSegurosDisponiveis,
  processarAutorizacao,
} from '../../ducks/Customer';

import Select from 'react-select';
import {SelectStyles} from '../../constants';

import {relacoesBuscar} from '../../ducks/Select';

import './styles.scss';
class AdditionalCard extends Component {
  formIsValid = () => {
    var isValid = [];

    this.props.cartoesAdicionais.forEach((cartaoAdicional) => {
      isValid.push(ValidationService.validate(cartaoAdicional, validation));
    });

    return !isValid.includes(false);
  };

  async componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.AdditionalCard.title);
    this.props.relacoesBuscar();
  }

  state = {
    diasDeVencimento: null,
    tempoDaMensagem: 5000,
    numeroTentativas: 0,
    numeroTentativasMaximas: 2,
    notification: null,
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (
      !(await this.props.processaSituacaoPortadorFinalizada(this.props.chave))
    ) {
      for (
        let index = 0;
        index < this.props.cartoesAdicionais.length;
        index++
      ) {
        this.props.cartoesAdicionais[index].dataNascimento = moment(
          this.props.cartoesAdicionais[index].dataNascimento,
          'YYYY-MM-DD',
          true,
        ).isValid()
          ? moment(
              this.props.cartoesAdicionais[index].dataNascimento,
              'YYYY-MM-DD',
            ).format('DD/MM/YYYY')
          : this.props.cartoesAdicionais[index].dataNascimento;
      }

      if (!this.formIsValid()) return;

      this.iniciarConsultaSegurosDisponiveis();

      setTimeout(async () => {
        let chave = this.props.chave;
        const dados = {
          chave,
          cartoes: [...this.props.cartoesAdicionais],
        };

        await this.props.adicionarCartoesAdicionais(dados);
        await this.buscarSegurosRota();
      }, this.state.tempoDaMensagem);
    } else this.finalizarConsultaSegurosDisponiveis();
  };

  buscarSegurosRota = async () => {
    if (
      !(await this.props.processaSituacaoPortadorFinalizada(this.props.chave))
    ) {
      let chave = this.props.chave;
      let possuiSeguros = await this.props.consultarSegurosDisponiveis(chave);
      this.incrementaContador();
      await this.processaHandle(possuiSeguros);
    } else this.finalizarConsultaSegurosDisponiveis();
  };

  incrementaContador = () => {
    let {numeroTentativas} = this.state;
    numeroTentativas++;
    this.setState({numeroTentativas});

    console.log('Contador....', this.state.numeroTentativas, new Date());
  };

  processaHandle = async (possuiSeguros) => {
    // deu certo, finaliza o processo
    if (possuiSeguros.sucesso) {
      await this.handleSucessoConsultaSeguros(possuiSeguros);
      return;
    }

    // não deu certo, e retornou 422
    if (!possuiSeguros.sucesso && !possuiSeguros.reprocessar) {
      await this.handleSucessoConsultaSeguros([]);
      return;
    }

    let registrarDenovo = false;

    // não deu certo, mas é erro sistemico, precisa reprocessar
    if (!possuiSeguros.sucesso && possuiSeguros.reprocessar) {
      // ainda permite reprocessar ?
      if (this.state.numeroTentativas < this.state.numeroTentativasMaximas)
        registrarDenovo = true;
      else {
        // se não permitir vai mostrar mensagem e direcionar para a tela inicial
        this.finalizarConsultaSegurosDisponiveis();

        NotificationService.showValidationSingleError(
          'Ocorreu um erro inesperado, por gentileza acesse novamente o seu convite em alguns minutos.',
        ).then(() => {
          this.props.redirectToValidationAccessCode();
        });
      }

      if (registrarDenovo) {
        setTimeout(async () => {
          await this.buscarSegurosRota();
        }, 10000);
      }
    }
  };

  iniciarConsultaSegurosDisponiveis = () => {
    let notification = NotificationService.showMessageWithoutButton(
      'Aguarde um instante, estamos processando sua requisição.',
    );
    this.setState({notification});
  };

  handleSucessoConsultaSeguros = async (possuiSeguros) => {
    this.finalizarConsultaSegurosDisponiveis();
    if (possuiSeguros.seguros && possuiSeguros.seguros.length >= 1) {
      this.props.redirectToHireInsurance();
    } else {
      let chave = this.props.chave;
      const dados = {
        chave,
        autorizacao: [],
      };
      const processarAutorizacaoResponse =
        await this.props.processarAutorizacao(dados);
      if (processarAutorizacaoResponse.sucesso) {
        this.props.redirectToSignature();
      } else {
        await NotificationService.showValidationSingleError(
          'Ocorreu um erro inesperado, por gentileza acesse novamente o seu convite em alguns minutos.',
        ).then(() => {
          this.props.redirectToValidationAccessCode();
        });
      }
    }
  };

  finalizarConsultaSegurosDisponiveis = () => {
    if (this.state.notification != null) {
      try {
        this.state.notification.close();
      } catch {}
    }

    let numeroTentativas = 1;
    this.setState({numeroTentativas});
  };

  handleChange = (prop, value, index) => {
    this.props.updateCartaoAdicional({prop, value, index});
  };

  addNovoMembro = () => {
    this.props.addNovoCartaoAdicional();
  };

  removerMembro = (index) => {
    this.props.removeCartaoAdicional({index});
  };

  filterName = (value) => {
    return value.toUpperCase();
  };

  selectOptions = (parentescos) => {
    return parentescos.map((parentesco) => ({
      label: parentesco.descricao,
      value: parentesco.id,
    }));
  };

  selectDefaultValue = (idParentesco, parentescos) => {
    const value = {
      ...parentescos.find(
        (parentesco) => parentesco.id.toString() === idParentesco.toString(),
      ),
    };

    return value.id ? {value: value.id, label: value.descricao} : null;
  };

  render() {
    return (
      <ScreenNotificationDefault
        title={
          <p>Você pode solicitar até 2 cartões adicionais totalmente GRÁTIS</p>
        }
        contentCustom={
          <div className="div-data-registration">
            <form className="form" id="frm" onSubmit={this.handleSubmit}>
              {this.props.cartoesAdicionais.map((item, index) => (
                <div className="form-inputs" key={index}>
                  <InputText
                    type="text"
                    value={this.props.cartoesAdicionais[
                      index
                    ].nomeCompleto.toUpperCase()}
                    id={`nome_${index}_value`}
                    name="nome"
                    maxLength="19"
                    onChange={(ev) =>
                      this.handleChange(
                        'nomeCompleto',
                        this.filterName(ev.target.value),
                        index,
                      )
                    }
                    placeholder="Nome Completo"
                  />

                  <InputText
                    type="tel"
                    value={
                      moment(
                        this.props.cartoesAdicionais[index].dataNascimento,
                        'YYYY-MM-DD',
                        true,
                      ).isValid()
                        ? moment(
                            this.props.cartoesAdicionais[index].dataNascimento,
                            'YYYY-MM-DD',
                          ).format('DD/MM/YYYY')
                        : this.props.cartoesAdicionais[index].dataNascimento
                    }
                    onChange={(ev) =>
                      this.handleChange(
                        'dataNascimento',
                        moment(ev.target.value, 'YYYY-MM-DD', true).isValid()
                          ? moment(ev.target.value, 'YYYY-MM-DD').format(
                              'DD/MM/YYYY',
                            )
                          : ev.target.value,
                        index,
                      )
                    }
                    mask="99/99/9999"
                    id={`nascimento_${index}_value`}
                    name="nascimento"
                    placeholder="Data de Nascimento"
                  />

                  <div className="form-group">
                    <label className="form-label" htmlFor="parentesco">
                      Parentesco
                    </label>
                    <Select
                      className="select-input"
                      isSearchable={true}
                      isClearable={true}
                      id="parentesco"
                      name="parentesco"
                      styles={SelectStyles}
                      noOptionsMessage={() => 'Nenhuma opção encontrada'}
                      placeholder="Selecione..."
                      value={this.selectDefaultValue(
                        this.props.cartoesAdicionais[index].parentesco,
                        this.props.parentescos,
                      )}
                      onChange={(ev) => {
                        this.handleChange(
                          'parentesco',
                          ev ? ev.value : '',
                          index,
                        );
                      }}
                      options={this.selectOptions(this.props.parentescos)}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Sexo</label>
                    <div
                      className="checkbox"
                      onClick={() => this.handleChange('sexo', 'M', index)}
                    >
                      <input
                        className="form-field"
                        type="radio"
                        name={'sexo' + index}
                        value="M"
                        checked={
                          this.props.cartoesAdicionais[index].sexo === 'M'
                        }
                        onChange={(ev) =>
                          this.handleChange('sexo', ev.target.value)
                        }
                      />
                      <label htmlFor="M">Masculino</label>
                    </div>

                    <div
                      className="checkbox"
                      onClick={() => this.handleChange('sexo', 'F', index)}
                    >
                      <input
                        className="form-field"
                        type="radio"
                        name={'sexo' + index}
                        value="F"
                        checked={
                          this.props.cartoesAdicionais[index].sexo === 'F'
                        }
                        onChange={(ev) =>
                          this.handleChange('sexo', ev.target.value)
                        }
                      />
                      <label htmlFor="F">Feminino</label>
                    </div>
                  </div>
                  {this.props.cartoesAdicionais.length > 1 && (
                    <div
                      className="div-remove"
                      onClick={() => this.removerMembro(index)}
                    >
                      Remover
                      <AiOutlineMinusCircle />
                    </div>
                  )}
                </div>
              ))}
              {this.props.cartoesAdicionais.length <= 1 && (
                <div className="div-add-more">
                  <div>
                    <h2>Deseja Incluir mais adicionais?</h2>
                  </div>
                  <div className="pointer" onClick={this.addNovoMembro}>
                    Clique Aqui
                    <AiOutlinePlusCircle />
                  </div>
                </div>
              )}
            </form>
          </div>
        }
        contentButtons={
          <div className="div-data-professional">
            <Footer
              backHandle={() => {
                this.props.redirectToYourCard();
              }}
              nextForm="frm"
            />
          </div>
        }
      />
    );
  }
}

const mapStateToProps = ({customer, select}) => {
  const {chave, dadosPessoais, cartoesAdicionais, cartao} = customer;
  const {parentescos} = select;
  return {chave, dadosPessoais, cartoesAdicionais, cartao, parentescos};
};

export default connect(mapStateToProps, {
  redirectToYourCard,
  redirectToSignature,
  redirectToValidationAccessCode,
  redirectToHireInsurance,
  adicionarCartoesAdicionais,
  consultarSegurosDisponiveis,
  updateProps,
  processaSituacaoPortadorFinalizada,
  updateCartaoAdicional,
  addCartaoAdicional,
  addNovoCartaoAdicional,
  removeCartaoAdicional,
  processarAutorizacao,
  relacoesBuscar,
})(AdditionalCard);
